import React from "react";
import { Link } from "react-router-dom";

export default function CTA({ title = "Protect the site before the next incident", note = "Deployment subject to unit availability and site location." }) {
  return (
    <section data-testid="section-final-cta" className="bg-solar text-black">
      <div className="container-x py-16 md:py-20 grid md:grid-cols-[1.4fr_1fr] gap-10 items-center">
        <div>
          <div className="eyebrow text-black/70 mb-3">Take the next step</div>
          <h2 className="text-black mb-4">{title}</h2>
          <p className="text-black/80 max-w-xl text-lg">{note}</p>
        </div>
        <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
          <Link
            data-testid="cta-request-assessment"
            to="/request-a-quote"
            className="inline-block bg-black text-solar font-bold uppercase tracking-wider px-6 py-4 border border-black hover:bg-obsidian transition-colors text-center"
          >
            Request a Security Assessment
          </Link>
          <a
            data-testid="cta-call-btn"
            href="tel:7029290390"
            className="inline-block border-2 border-black text-black font-bold uppercase tracking-wider px-6 py-4 hover:bg-black hover:text-solar transition-colors text-center"
          >
            Call 702-929-0390
          </a>
        </div>
      </div>
    </section>
  );
}
